import React from 'react';
import { useTranslation } from 'react-i18next';
import { EiqInput, EiqSelect } from 'eiq-storybook';
import s from '../CapAction.styles';
import { ACTION_RESOURCE_TYPE_VALUES, ACTION_RESOURCE_INVESTMENT_DEFAULT_VALUES } from '../utils';

export const ResourceInvestment = ({ resources, currencyOptions, resource, isAdmin, editableStatus, isCapManager, setValue, errors }) => {
  const { t } = useTranslation();  
  let errorObject = {};
  const isEditable =  editableStatus; 
  const setResourcesValue = (fieldName, val) => {
    const resourceInvestmentIndex = resources?.findIndex((item) => resource && (item?.resourceType === ACTION_RESOURCE_TYPE_VALUES.investment));
    let resourceInvestmentObj = {};
    if(resource) {
      resourceInvestmentObj = resource;
      resourceInvestmentObj[fieldName] = val;
    }else{
      resourceInvestmentObj = {...ACTION_RESOURCE_INVESTMENT_DEFAULT_VALUES};
      resourceInvestmentObj.resourceType = ACTION_RESOURCE_TYPE_VALUES.investment;
      resourceInvestmentObj[fieldName] = val;
    }
    const updatedResources = resources ? [...resources] : [];
    if(resourceInvestmentIndex === 0 || resourceInvestmentIndex !== -1 ){
      updatedResources[resourceInvestmentIndex] = resourceInvestmentObj;
    }else{      
      const resourceIndex = resources?.findIndex((item) => ACTION_RESOURCE_TYPE_VALUES.investment === item?.resourceType);
      if(resourceIndex === 0 || resourceIndex !== -1 ) updatedResources[resourceIndex] = resourceInvestmentObj;
      else updatedResources[resources ? resources.length : 0] = resourceInvestmentObj;
    } 
    setValue('resources', updatedResources)
  };
  if(errors && typeof errors !== 'string'){
    const resourceInvestmentIndex = resources?.findIndex((item) => resource && (item?.id === resource?.id && item?.resourceType === ACTION_RESOURCE_TYPE_VALUES.investment));
    errorObject = errors[resourceInvestmentIndex];
  }

  return (
  <>
    <s.ResourceDetailWrapper>
        <s.ResourceTitleLabel className='mandatory'>{t('COLUMN_DESCRIPTION')}</s.ResourceTitleLabel>
        <div className='pr-20'>
            <EiqInput 
                type='text'
                id='resourceInvestmentDescription'
                autoFocus
                wrapperClassName='DescriptionInputWrapper eiqWrapper'
                errorMessage={errorObject?.details}
                value={resource?.details}
                placeholder={t('CLICK_HERE_TO_ENTER_TEXT')}
                onChange={(e) => setResourcesValue('details', e.target.value)}
                disabled={!isEditable}
            />
            </div>
          <s.ResourceFlex>            
          <s.ResourceDropdownWrapper id="resourceInvestmentCurrency">
              <EiqSelect 
                label={t('CURRENCY')}
                backspaceRemovesValue={false}
                isClearable={false}
                isDisabled={!isEditable}
                wrapperClass='resourceNoOfWrapper'
                onChange={(_name, option) => {
                  setResourcesValue("currencyId", option.value);
                }}
                options={currencyOptions}
                placeholder={t('CHOOSE')}
                error={errorObject?.currencyId}
                touched={true}
                value={currencyOptions.find(currency => currency.value === resource?.currencyId)}
              />
            </s.ResourceDropdownWrapper>
       
          
          <div className='totalCost rightToDropdown'>
              <s.ResourceTitleLabel className='mandatory'>{t('TOTAL_COST')}</s.ResourceTitleLabel>
                  <div>
                    <EiqInput
                      type='number'
                      id='resourceInvestmentTotalCost' 
                      wrapperClassName='InputWrapper eiqWrapper'
                      errorMessage={errorObject?.costs}
                      value={resource?.costs}
                      placeholder={t('CLICK_HERE_TO_ENTER_TEXT')}
                      onChange={(e) => setResourcesValue("costs", parseFloat(e.target.value, 10))}
                      disabled={!isEditable}
                    />
                </div>
            </div>
            </s.ResourceFlex>  
    </s.ResourceDetailWrapper> 
  </>)

};